import { Card } from "../../../../components/ui/cards/Card";
import { CardHeader } from "../../../../components/ui/cards/CardHeader";
import { CardBody } from "../../../../components/ui/cards/CardBody";
import { Button, Header4, Header6, TextInput } from "../../../../components/ui";
import localization from "../../../../config/localization";
import { useState } from "react";
import { PhoneNumberInput } from "../../../../components/ui/inputs/PhoneNumberInput";
import {
  VerificationChannel,
  VerificationChannelsArray,
} from "../../../auth/constants/verificationChannel";
import { Validations } from "../../../../models/constants/validations";
import { OtpModal } from "../../../../components/ui/modals";
import {
  RESET_PASSWORD_TYPE_FORGOT,
  RESET_PASSWORD_TYPES,
} from "../../../auth/models/resetPasswordType";
import { authService } from "../../../auth";
import { localStorageService } from "../../../../services";
import { ResetPassword } from "../resetPassword/ResetPassword";
import errorModal from "../../../../services/errorModal.service";

export function ForgotPassword() {
  const [username, setUsername] = useState("");
  const [verificationChannel, setVerificationChannel] = useState<string>(
    VerificationChannel.Email.value,
  );
  const [notificationData, setNotificationData] = useState<string>("");

  const [usernameErrorMessage, setUsernameErrorMessage] = useState<string | null>(null);
  const [notificationDataErrorMessage, setNotificationDataErrorMessage] = useState<string | null>(null);

  const [openVerifyOtpModal, setOpenVerifyOtpModal] = useState(false);
  const [otpErrorMessage, setOtpErrorMessage] = useState("");

  const [redirectToResetPassword, setRedirectToResetPassword] = useState(false);

  const clearUsernameErrorOnFocus = () => {
    setUsernameErrorMessage((prev) => (prev ? null : prev));
  };

  const clearNotificationDataErrorOnFocus = () => {
    setNotificationDataErrorMessage((prev) => (prev ? null : prev));
  };

  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setUsername(value);
    setUsernameErrorMessage((prev) => (value ? null : prev));
  };

  const handleNotificationDataChange = (value: string) => {
    setNotificationData(value);
    setNotificationDataErrorMessage((prev) => (value ? null : prev));
  };

  const checkValidation = () => {

    let isValid = true;
    setUsernameErrorMessage(null);
    setNotificationDataErrorMessage(null);

    // Username validation
    if (!username) {
      setUsernameErrorMessage("error_Username");
      isValid = false;
    }

    // Notification data validation
    if (!notificationData) {
      setNotificationDataErrorMessage("BlankNotificationDataError_message");
      isValid = false;
    }
    else if (verificationChannel === VerificationChannel.Email.value && !Validations.email.regex.test(notificationData)) {
      setNotificationDataErrorMessage("valid_email");
      isValid = false;
    }
    else if (verificationChannel === VerificationChannel.Phone.value && !Validations.mobile.regex.test(notificationData)) {
      setNotificationDataErrorMessage("mobile_validation_error");
      isValid = false;
    }

    return isValid;
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!checkValidation()) {
      return;
    }
    authService.forgotPassword(username, notificationData, verificationChannel === VerificationChannel.Email.value
    )
      .then((response) => {

        if (response.isSuccess && response?.message) {
          localStorageService.setItem("resetToken", response?.message);
          setOpenVerifyOtpModal(true);
        }
        else {
          errorModal.showErrorModal(response.statusCode, response.message, false);
        }
      });
  }

  const handleSendForgotPasswordOtp = () => {
    setOtpErrorMessage("");
    authService
      .forgotPassword(
        username,
        notificationData,
        verificationChannel === VerificationChannel.Email.value,
      )
      .then((response) => {
        if (response.isSuccess && response?.message) {
          localStorageService.setItem("resetToken", response?.message);
          setOpenVerifyOtpModal(true);
        } else {
          errorModal.showErrorModal(response.statusCode, response.message);
        }
      });
  };

  const handleVerifyPasswordOtp = (otp: string) => {
    setOtpErrorMessage("");
    authService.verifyForgotPasswordCode(otp).then((response) => {
      if (response.isSuccess) {
        setOpenVerifyOtpModal(false);
        setTimeout(() => {
          setRedirectToResetPassword(true);
        }, 1000);
      } else {
        setOtpErrorMessage(response.message);
      }
    });
  };

  let content;

  if (redirectToResetPassword) {
    content = (
      <ResetPassword
        resetPasswordType={RESET_PASSWORD_TYPES.find(
          (t) => t.type === RESET_PASSWORD_TYPE_FORGOT,
        )}
      ></ResetPassword>
    );
  } else {
    content = (
      <>
        <div>
          <div>
            <Header4 className="text-white mb-6 uppercase">
              {localization.forgot_password_link}
            </Header4>
          </div>
        </div>

        <form onSubmit={handleSubmit}>

          <div className="flex flex-col gap-3">
            <TextInput
              label={localization.username}
              placeholder={localization.username}
              value={username}
              isRequired={true}
              error={usernameErrorMessage && localization.getString(usernameErrorMessage)}
              onChange={handleUsernameChange}
              onFocus={clearUsernameErrorOnFocus}
              maxLength={15}
            />

            <div className="border border-[#242426] rounded-lg px-4 py-3 bg-black shadow">
              <Header6 className="font-bold mb-3">
                {localization.send_details_on_email_or_phone}
              </Header6>

              <div className="flex gap-2 mb-3">
                {VerificationChannelsArray.map((channel) => (
                  <Button
                    key={channel.value}
                    className={`px-6 py-2 rounded-md  font-medium ${verificationChannel === channel.value ? "bg-white-gradient text-black" : "border border-[#4B4B4B]"}`}
                    onClick={() => {
                      setVerificationChannel(channel.value);
                      setNotificationData("");
                      setNotificationDataErrorMessage(null);
                    }}

                  >
                    {channel.label}
                  </Button>
                ))}

              </div>

              <div className="flex flex-col sm:flex-row gap-3">
                <div className="w-full sm:flex-1">
                  {verificationChannel === VerificationChannel.Email.value ? (
                    <TextInput
                      value={notificationData}
                      onChange={(e) => handleNotificationDataChange(e.target.value)}
                      error={notificationDataErrorMessage && localization.getString(notificationDataErrorMessage)}
                      placeholder={localization.email}
                      onFocus={clearNotificationDataErrorOnFocus}
                      maxLength={240}
                    />
                  ) : (
                    <PhoneNumberInput
                      value={notificationData}
                      maxLength={10}
                      showCountryCode={true}
                      showCountryDropdown={true}
                      className="h-12"
                      error={notificationDataErrorMessage && localization.getString(notificationDataErrorMessage)}
                      onChange={(value) => handleNotificationDataChange(value)}
                      onFocus={clearNotificationDataErrorOnFocus}
                      placeholder={localization.mobile}
                    />
                  )}
                </div>

                <Button
                  type="submit"
                  className="h-12 w-full sm:w-auto sm:min-w-[116px] px-6 text-white rounded-md bg-primary-gradient hover:opacity-90"
                >
                  {localization.send}
                </Button>
              </div>
            </div>

          </div>
        </form>

        <OtpModal
          open={openVerifyOtpModal}
          onClose={() => setOpenVerifyOtpModal(false)}
          onSubmit={handleVerifyPasswordOtp}
          onResend={handleSendForgotPasswordOtp}
          title={localization.verify_otp}
          description={
            localization.enter_the_4_digit_code_sent_to_your_email_or_phone
          }
          showTimer={true}
          timerValue={59}
          errorMessage={otpErrorMessage}
        />
      </>
    );
  }
  return (
    <Card>
      <CardHeader showBackButton={true} showLogo={true} />
      <CardBody showGradient={true} className="pb-10">
        {content}
      </CardBody>
    </Card>
  );
}
